export const formatListWithOr = (arr: Array<string>): string => {
	return arr.map((str) => str.toUpperCase()).join(', ').replace(/,([^,]*)$/, ' or$1');
};
